import React from 'react';
import { useAuth } from '../context/AuthContext';
import PPMScreen from '../components/PPMScreen';

// Standalone PPM + Production File Checklist page — for production/quality roles
// without full Order Execution access. Same component as the OE → PPM tab.
export default function PPMPage() {
  const { user } = useAuth();
  return (
    <div style={{ minHeight: '100vh', background: 'transparent' }}>
      <div style={{ padding: 24 }}>
        <h2 style={{ margin: '0 0 16px', color: '#2D2C72', fontSize: 22 }}>📋 PPM & Production File Checklist</h2>
        <PPMScreen user={user} />
      </div>
    </div>
  );
}
